/* eslint-disable import/no-webpack-loader-syntax */

import root from "react-shadow";
import Viewer from "./Viewer.jsx";
import style from "./PdfViewer.css?inline";

function PdfViewer(props) {
  const { url, name = "untitled", mode = "light", onClose } = props;
  return (
    <pdf-viewer id="pdf-viewer" style={{ width: "100%", height: "100%" }}>
      <root.div style={{ width: "100%", height: "100%" }}>
        <style>{style}</style>
        <Viewer url={url} name={name} mode={mode} onClose={onClose} />
      </root.div>
    </pdf-viewer>
  );
}

export default PdfViewer;
